module.exports = __webpack_public_path__ + "media/images/gift_plan/bubble-img-introduction-3fb049e2e4e0944eb8f72c6124ff2657.png";